module.exports = __webpack_public_path__ + "media/KRBS 4mb.c4680cdb.mp4";